// No external assets — scene is fully procedural
export default []
